import { SINGAL_JOB_ERROR } from "../GetJob/actiontype";
import { GET_COURSE_ERROR, GET_COURSE_REQUEST, GET_COURSE_SUCCESS, SINGAL_COURSE_REQUEST, SINGAL_COURSE_SUCCESS } from "./actiontype";


const initstate = {
     course:[],
     isloading:false,
     isError:false,
     sLoading:false,
     sError:false,
     data:{}
}

export const reducer = (state=initstate, {payload, type})=> {
    switch (type) {
        case GET_COURSE_REQUEST:return {...state, isloading:true}
        case GET_COURSE_SUCCESS:return {...state, isloading:false , course:payload}   
        case GET_COURSE_ERROR:return {...state, isloading:false,isError:true}
        case SINGAL_COURSE_REQUEST:return {...state , sloading:true}
        case SINGAL_COURSE_SUCCESS:return {...state, sloading:false, data:payload}
        case SINGAL_JOB_ERROR:return {...state, sloading:false, sError:true}
        default:return state
           
    }
}